import React, { useRef } from 'react'
import emailjs from '@emailjs/browser';
import useAOS from './useAos';

export default function ContactForm() {
  useAOS();
  const form = useRef();

  const sendEmail = (e) => {
    e.preventDefault();

    emailjs
      .sendForm('service_wikbzbc', 'template_iz7j5hl', form.current, 'VaaZj9LHtIghrBCnL')
      .then(
        () => {
          alert('Message sent successfully!');
          form.current.reset(); // Reset form after successful submission
        },
        (error) => {
          console.error('FAILED...', error.text);
          alert('Failed to send message. Please try again later.');
        }
      );
  };

  return (
    <section
    data-aos="fade-left"
    data-aos-delay="300"
    data-aos-duration="600">
        <div className="mx-auto max-w-screen-xl px-4 py-16 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 gap-x-16 gap-y-8 lg:grid-cols-5">
            <div className="lg:col-span-2 lg:py-12">
              <p className="max-w-xl text-lg">
              Have a project in mind? Whether you need expert planning, interior design, consulting, or supervision, Arcium Studio is here to bring your vision to life. Get in touch with us today, and let’s create a solution tailored to your needs.
              </p>

              <div className="mt-8">
                <a href="https://wa.me/37745541556" className="text-2xl font-bold text-bannerBg">+377 45 541 556</a>
                <address className="mt-2 not-italic">office@arcium-studio</address>
                <address className="mt-2 not-italic">Muharrem Ibrahimi, Gjilan Kosovo</address>
              </div>
            </div>


            <div className="rounded-lg bg-white p-8 bg-hover shadow-lg lg:col-span-3 lg:p-12">
              <form ref={form} onSubmit={sendEmail} className="space-y-4">
                <div>
                  <label className="sr-only" htmlFor="name">Name</label>
                  <input
                    className="w-full rounded-lg bg-background text-white border-gray p-3 text-sm"
                    placeholder="Name"
                    type="text"
                    id="name"
                    name="user_name"
                    required
                  />
                </div>

                <div className="grid grid-cols-1 gap-4 sm:grid-cols-2">
                  <div>
                    <label className="sr-only" htmlFor="email">Email</label>
                    <input
                      className="w-full rounded-lg text-white bg-background border-gray p-3 text-sm"
                      placeholder="Email address"
                      type="email"
                      id="email"
                      name="user_email"
                      required
                    />
                  </div>

                  <div>
                    <label className="sr-only" htmlFor="phone">Phone</label>
                    <input
                      className="w-full rounded-lg border-gray text-white bg-background p-3 text-sm"
                      placeholder="phone"
                      type="tel"
                      id="phone"
                      name="user_phone"
                    />
                  </div>
                </div>

                <div>
                  <label className="sr-only" htmlFor="message">Message</label>
                  <textarea
                    className="w-full rounded-lg border-gray p-3 bg-background text-white text-sm"
                    placeholder="message"
                    rows="8"
                    id="message"
                    name="message"
                    required
                  ></textarea>
                </div>
                <div className='flex items-center justify-start'>
                <label>
                  <input type="checkbox" required className='h-4 w-4 mr-2'/>
                  I have read and agree to the <a href="/privacyPolicy" className='text-gray underline' target="_blank">Privacy Policy</a>
                </label>
                </div>

                <div className="mt-4">
                  <button
                    type="submit"
                    className="inline-block w-full rounded-lg bg-background px-5 py-3 font-medium text-gray hover:bg-color1 hover:text-background sm:w-auto transition ease-in-out duration-300"
                  >
                    Send
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </section>
)
}
